import moment from 'moment';

export const isChequeOrPdc = (method) => ['CHEQUE', 'PDC'].includes((method || '').trim().toUpperCase());

export const MAX = { chequeNo: 50, drawnBank: 255, refNo: 50, paidTo: 255, narration: 2500 };

const blank = (v) => !(v || '').toString().trim();

/**
 * Edit-form validation (section 3.3). Returns { fieldKey: message }; empty means valid.
 * values: { voucherDate, bankAccount, paymentMethod, chequeNo, chequeDate, drawnBank, refNo, paidTo, narration }
 * options: { financialYearRange: { from, to, label } | null } - when unknown the server enforces the year.
 */
export const validateRefundEdit = (values, { financialYearRange = null } = {}) => {
    const e = {};

    if (!values.voucherDate) e.voucherDate = 'Enter Voucher Date.';
    else if (financialYearRange) {
        const d = moment(values.voucherDate);
        if (d.isBefore(financialYearRange.from, 'day') || d.isAfter(financialYearRange.to, 'day')) {
            e.voucherDate = `Voucher date must stay within financial year ${financialYearRange.label}.`;
        }
    }
    if (!values.bankAccount) e.bankAccount = 'Select Bank / Cash Account.';
    if (blank(values.paymentMethod)) e.paymentMethod = 'Select Payment Method.';

    if (isChequeOrPdc(values.paymentMethod)) {
        if (blank(values.chequeNo)) e.chequeNo = 'Enter Cheque No.';
        if (!values.chequeDate) e.chequeDate = 'Enter Cheque Date.';
        if (!e.chequeNo && (values.chequeNo || '').length > MAX.chequeNo) e.chequeNo = `Cheque No cannot exceed ${MAX.chequeNo} characters.`;
        if ((values.drawnBank || '').length > MAX.drawnBank) e.drawnBank = `Drawn Bank cannot exceed ${MAX.drawnBank} characters.`;
    }
    if ((values.refNo || '').length > MAX.refNo) e.refNo = `Ref No cannot exceed ${MAX.refNo} characters.`;
    if ((values.paidTo || '').length > MAX.paidTo) e.paidTo = `Paid To cannot exceed ${MAX.paidTo} characters.`;
    if ((values.narration || '').length > MAX.narration) e.narration = `Narration cannot exceed ${MAX.narration} characters.`;
    return e;
};
